import { useMemo, useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { collectionCategories, collectionItems } from "@/mocks/home";

export default function Collections() {
  const [activeCategory, setActiveCategory] = useState(collectionCategories[0]);

  const filtered = useMemo(() => {
    if (activeCategory === "全部") return collectionItems;
    return collectionItems.filter((item) => item.category === activeCategory);
  }, [activeCategory]);

  return (
    <section id="collections" className="scroll-mt-section bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <SectionHeading
              eyebrow="片单收藏"
              title="收藏与追更，集中管理"
              subtitle="一键收藏感兴趣的内容，加入追更列表后可在片单中集中查看。下面的示例按类型筛选，帮助你快速找到想继续看的条目。"
            />
            <p className="text-sm text-foreground-500 whitespace-nowrap">
              共 {filtered.length} 部 · 示例片单
            </p>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 flex flex-wrap gap-2">
            {collectionCategories.map((category) => (
              <button
                key={category}
                type="button"
                aria-pressed={category === activeCategory}
                onClick={() => setActiveCategory(category)}
                className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                  category === activeCategory
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 border border-background-200 hover:text-foreground-900"
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {filtered.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <article className="h-full flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-100">
                <div className="w-full aspect-[3/4] bg-background-200 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} 片单封面`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="flex flex-col flex-1 p-4 md:p-5">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <span className="rounded-full bg-secondary-100 text-secondary-900 px-2.5 py-0.5 text-xs whitespace-nowrap">
                      {item.category}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-accent-700">{item.meta}</p>
                  <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed flex-1">
                    {item.note}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-bookmark-3-line text-primary-500" />
                    已加入收藏
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}